import React from 'react'

import { useMainQueryData } from './useMainQueryData'

export const useMainQuerySurveys = () => {
  const brandAccount = useMainQueryData()

  return React.useMemo(
    () => brandAccount?.surveys ?? [],
    [brandAccount?.surveys],
  )
}
